import React from 'react';
import { CompanyRegistration, CompanyRegistrationErrors } from '../../types';
import CompanyInfoSection from './sections/CompanyInfoSection';
import ContactInfoSection from './sections/ContactInfoSection';
import CommercialInfoSection from './sections/CommercialInfoSection';
import AccessInfoSection from './sections/AccessInfoSection';

interface CompanyFormProps {
  formData: Partial<CompanyRegistration>;
  errors: CompanyRegistrationErrors;
  isSubmitting: boolean;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
}

const CompanyForm: React.FC<CompanyFormProps> = ({
  formData,
  errors,
  isSubmitting,
  onInputChange,
  onSubmit
}) => {
  return (
    <form className="uk-form-stacked" onSubmit={onSubmit}>
      <CompanyInfoSection 
        formData={formData}
        errors={errors}
        onInputChange={onInputChange}
      />
      
      <ContactInfoSection 
        formData={formData}
        errors={errors}
        onInputChange={onInputChange}
      />
      
      <CommercialInfoSection 
        formData={formData}
        errors={errors}
        onInputChange={onInputChange}
      />
      
      <AccessInfoSection 
        formData={formData}
        errors={errors}
        onInputChange={onInputChange}
      />
      
      <div className="uk-margin-large-top">
        <button 
          type="submit" 
          className="uk-button uk-button-primary uk-button-large uk-width-1-1"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <i className="fas fa-spinner fa-spin uk-margin-small-right"></i>
              Creando cuenta...
            </>
          ) : (
            <>
              <i className="fas fa-building uk-margin-small-right"></i>
              Registrar Mi Empresa
            </>
          )}
        </button>
      </div>
      
      <div className="uk-margin-medium-top uk-text-center">
        <p className="uk-text-small">
          ¿Ya tienes una empresa registrada? <button type="button" className="uk-link uk-button-text">Inicia sesión aquí</button>
        </p>
      </div>
    </form>
  );
};

export default CompanyForm;
